import '@/modules/card';
import '@/modules/pagination';
import { FacetFilters, FacetFiltersForm, PriceRange, FacetRemove } from '@/modules/filter';
import GridLayoutToggle from '@/modules/grid-layout-toggle';

if (document.getElementsByTagName('facet-filters-form')) {
    if(!customElements.get('face-filters')) {
        customElements.define('facet-filters', FacetFilters);
    }
    
    customElements.define('facet-filters-form', FacetFiltersForm);
    customElements.define('price-range', PriceRange);
    customElements.define('facet-remove', FacetRemove);
}

if ([...document.querySelectorAll('.js-grid-layout-toggle')].length) {
    [...document.querySelectorAll('.js-grid-layout-toggle')].forEach(element => new GridLayoutToggle(element));
}
